import { useState, useEffect } from 'react';
import Web3 from 'web3';

import { useWeb3React } from '@web3-react/core';
import { WalletConnectConnector } from "@web3-react/walletconnect-connector"
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import { InjectedConnector } from "@web3-react/injected-connector";
import { Circles } from 'react-loader-spinner'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import { ICOABI, ERC20ABI, ICO_ADDRESS, tokens, CHAIN} from '../../configs';

export const MetamaskWallet = new InjectedConnector({
    supportedChainIds: [1, 3, 4, 5, 42, 56,97]
  });
  
export const CoinbaseWallet = new WalletLinkConnector({
    url: `https://bsc-dataseed1.binance.org`,
    appName: "LuxuryShares ICO",
    supportedChainIds: [1, 3, 4, 5, 42, 56,97],
});

export const WalletConnect = new WalletConnectConnector({
    rpcUrl: `https://data-seed-prebsc-2-s2.binance.org:8545`,
    bridge: "https://bridge.walletconnect.org",
    qrcode: true,
});


const web3_read = new Web3("https://bsc-dataseed.binance.org/");

const decodeError = function (message)  {
    if(!message) return "";
    let m = message.replace("execution reverted: ", "");
    if(String(m).includes("insufficient funds"))
        m = "Insufficient funds"
    return ": " + m;
}

export default function Popup() {
    
    const { activate, deactivate, account, library, chainId, active } = useWeb3React();

    const [isPopup, openPopup] = useState(false);
    const [amount0, setAmount0] = useState(200);
    const [amount1, setAmount1] = useState(200);
    const [usdBalance, setUsdBalance] = useState("0");
    const [walletList, showWalletList] = useState(false);

    const [selectedToken, selectToken] = useState(0);
    const [approved, setApproved] = useState(false);
    const [allowance, setAllowanceAmount] = useState(0);

    const [overlay, showOverlay] = useState(false);

    const handleConnectProvider = async(provider) => {
        try  {

          switch(provider) {
            case 'WalletConnect':
                activate(WalletConnect);
                break;
            case 'Coinbase':
                activate(CoinbaseWallet);
                break;
            case 'MetaMask':
                activate(MetamaskWallet);
                break;
            default:
                activate(MetamaskWallet);
          }
        } catch (e) {
        }
    };

    const switchNetwork = async (chainId) => {
        try {
            await library.provider.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: CHAIN === 56 ? "0x38" : "0x61" }],
            });
        } catch (switchError) {
            // console.error(switchError);
            // 4902 error code indicates the chain is missing on the wallet
            if (switchError.code === 4902) {
                try {
                await library.provider.request({
                    method: "wallet_addEthereumChain",
                    params: [
                    {
                        chainId: "0x38",
                        rpcUrls: ["https://bsc-dataseed1.binance.org"],
                        chainName: "Binance Smart Chain Mainnet",
                        nativeCurrency: { name: "BNB", decimals: 18, symbol: "BNB" },
                        blockExplorerUrls: ["https://bscscan.com"],
                        // iconUrls: ["https://harmonynews.one/wp-content/uploads/2019/11/slfdjs.png"]
                    }
                    ],
                });
                } catch (error) {
                console.error(error)
                }
            }
        }
    };

    const disconnectWallet = async () => {
        deactivate();
    }

    // Read
    async function callSmartContract(contract, func, args) {
        if(!contract) return false;
        if(!contract.methods[func]) return false;
        return contract.methods[func](...args).call();
    }
    
    // Write
    async function runSmartContract(contract, func, value, args) {
        if(!account) return false;
        if(!contract) return false;
        if(!contract.methods[func]) return false;
        return await contract.methods[func](...args).send({ from: account, value: value })
    }
    
    async function estimateGas(contract, func, value, args) {
        try {
            const gasAmount = await contract.methods[func](...args).estimateGas({from: account, value: value});
            return {
                success: true,
                gas: gasAmount
            }
        } catch(e) {
            let error = e;
            if(e.message.startsWith("Internal JSON-RPC error.")) {
                error = JSON.parse(e.message.substr(24));
            }
            return {
                success: false,
                gas: -1,
                message: error.message
            }
        }
    }
    
    const onApproveClicked = async() => {
        if(allowance < amount0) {
          await setAllowance(tokens[CHAIN][selectedToken].address, amount0);
        }
    }

    async function setAllowance() {
      showOverlay(true);
        try {
          const web3 = new Web3(library.provider);
          const tokenContract = new web3.eth.Contract(ERC20ABI, tokens[CHAIN][selectedToken].address);
    
          const args = [ICO_ADDRESS[CHAIN], "10000000000000000000000000000"];
          const func = "approve";
          const {success}  = await estimateGas(tokenContract, func, 0, args);
          if(!success) {
              return;
          }
          await runSmartContract(tokenContract, func, 0, args)
          setAllowanceAmount("10000000000000000000000000000");
          setApproved(true)
          toast.success("Successfully approved");
          showOverlay(false);
          return ;
        } catch (e) {
          console.log(e);
        }
        showOverlay(false);
        toast.error("Transaction failed.")
    }

    async function buyToken(amount) {
        
      showOverlay(true);
        try {
          const web3 = new Web3(library.provider);
          const icoContract = new web3.eth.Contract(ICOABI, ICO_ADDRESS[CHAIN]);
    
          const args = [amount0 ? Web3.utils.toWei("" + amount0) : "0", tokens[CHAIN][selectedToken].address];
          let func = "buy";
          if(tokens[CHAIN][selectedToken].symbol === "BNB") {
            func = "buyBNB";
            const {success, message} = await estimateGas(icoContract, func, amount0 ? Web3.utils.toWei("" + amount0) : "0", []);
            if(!success) {
                const m = decodeError(message);
                console.log(m);
                toast.error("Transaction Failed" + m);
                showOverlay(false);
                return;
            }

            await runSmartContract(icoContract, func, amount0 ? Web3.utils.toWei("" + amount0) : "0", [])
          } else {
            func = "buy";
            const {success, message} = await estimateGas(icoContract, func, 0, args);
            
            if(!success) {
                const m = decodeError(message);
                toast.error("Transaction Failed" + m);
                showOverlay(false);
                return;
            }
            await runSmartContract(icoContract, func, 0, args)
          }

          toast.success("Successfully purchased");
          showOverlay(false);
          return ;
        } catch (e) {
          showOverlay(false);
        }
        showOverlay(false);
        toast.error("Transaction Failed");
    }

    const checkApproved = async() => {
        if(tokens[CHAIN][selectedToken].symbol === "BNB") {
            setApproved(true)
            setAllowanceAmount("10000000000000000000000000000");
            return ;
        }
        try {
          const tokenContract = new web3_read.eth.Contract(ERC20ABI, tokens[CHAIN][selectedToken].address);
    
          const args = [account, ICO_ADDRESS[CHAIN]];
          const func = "allowance";
          const {success}  = await estimateGas(tokenContract, func, 0, args);
          if(!success) {
              return;
          }
          const res = await callSmartContract(tokenContract, func, args)
          const a = Web3.utils.toBN(res);
          const b = Web3.utils.toBN("" + amount0);
          setApproved(a.gte(b))
          setAllowanceAmount(res);
          
          return ;
        } catch (e) {
          setApproved(false)
          setAllowanceAmount(0)
        }
    }

    useEffect(() => {
        if(account) {
            showWalletList(false)
            checkApproved()
        } else {
          setApproved(false)
          setAllowanceAmount(0);
        }
    }, [account, amount0, selectedToken])

    useEffect(() => {
        calcUSD();
    }, [amount0, selectedToken])

    const calcUSD = async() => {
        const icoContract = new web3_read.eth.Contract(ICOABI , ICO_ADDRESS[CHAIN]);

        const args = [tokens[CHAIN][selectedToken].address, amount0 ? Web3.utils.toWei("" + amount0) : "0"];
        const func = "getEstimatedUSD";

        const res  = await callSmartContract(icoContract, func, args);
        let f = Web3.utils.fromWei(res);
        setUsdBalance(Number(f).toFixed(2));

        const args2 = [res];
        const t = await callSmartContract(icoContract, "getEstimations", args2);
        f = Web3.utils.fromWei(t);
        setAmount1(Number(f).toFixed(2));
    }

    useEffect(() => {
        if(chainId !== CHAIN) {
            switchNetwork();
        }
    }, [chainId])
    
    return (
        <div className="z-[1000]">
            <button className="bg-transparent hover:bg-[#a78859] text-[#a78859] hover:text-white border-[2px] border-[#a78859] border-solid mr-[10px] transition-all duration-300 min-w-[160px]" onClick={() => {openPopup(true)}}>
                { account && 
                <div className='flex flex-col justify-center items-center my-[6px] px-[15px]'>
                    <div className='font-bold'> BUY $LXS</div>
                    <div className='text-[12px]'> { `${account.substring(0, 7)}...${account.substring(38)}`}</div>
                </div>
                }
                { !account && 
                    <div className='my-[16px] px-[15px] font-bold'> Connect Wallet </div>
                }
            </button>
            { isPopup && 
                <div className="fixed top-0 left-0 flex w-full h-[100vh] justify-center bg-[#000000a0] backdrop-blur-xl flex overflow-y-auto py-[50px] z-[1000]">
                    
                    <div className="relative flex flex-col bg-white md:w-[720px] m-[20px] h-fit rounded-[20px] overflow-hidden pb-[10px] shadow-lg">
                        <div className="flex items-center bg-[#a78859] py-[10px]">
                            <h4 className="font-impact text-[32px] md:text-[48px] grow text-center text-white mb-[0px]">BUY LuxuryShares (LXS) </h4>
                            <button className="mr-[20px] p-[10px] md:pr-[10px] pr-[0px] text-white" onClick={() => {openPopup(false)}}>X</button>
                        </div>
                          <div className="flex flex-col md:flex-row pr-[20px] md:pr-[10px]">
                            <div className="flex flex-col p-[10px] ml-[20px] mt-[20px] md:w-[320px] bottom-b-[white] bottom-b-[1px]">
                                <h4 className="text-[24px] font-bold ml-[20px] text-[black]">Quick Buy with Crypto</h4>
                                <div className="text-[#363636]"> Buy LuxuryShares tokens in minutes using popular stable coins like USDT, USDC, BUSD, DAI, BNB, ETH or BTCB. Get your tokens delivered straight to your wallet after payment. Don't miss the one-time pre-launch price of $0.03c per token before LXS launches on the exchange.</div>
                                <div className='bg-[#f4f6fa] rounded-[12px] p-[5px] text-[red] mt-[10px] pl-[10px]'> 
                                    Minium amount in USD: $100.
                                </div>
                                <div className="grow min-h-[10px]"></div>
                                <div className="div-block-19">
                                    <h6 className="mb-[10px] text-[white]">PRICE OF TOKEN AFTER LAUNCH</h6>
                                    <div className="text-black flex h-[10px] rounded-full bg-[#775828] mb-[30px]">
                                        <div className="-mt-[3px] bg-[#a78859] w-[16px] h-[16px] relative rounded-full ml-[10px]">
                                            <div className="absolute top-[20px] text-[12px]">0.50</div>
                                        </div>
                                        <div className="-mt-[3px] bg-[#a78859] w-[16px] h-[16px] relative rounded-full ml-[30px]">
                                            <div className="absolute top-[20px] text-[12px]">0.70</div>
                                        </div>
                                        <div className="-mt-[3px] bg-[#a78859] w-[16px] h-[16px] relative rounded-full ml-[50px]">
                                            <div className="absolute top-[20px] text-[12px]">1.00</div>
                                        </div>
                                        <div className="-mt-[3px] bg-[#a78859] w-[16px] h-[16px] relative rounded-full ml-[70px]">
                                            <div className="absolute top-[20px] text-[12px]">1.50</div>
                                        </div>
                                        <div className="-mt-[3px] bg-[#a78859] w-[16px] h-[16px] relative rounded-full ml-[90px]">
                                            <div className="absolute top-[20px] text-[12px]">2.00</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            { !walletList ? 
                            <div className="flex flex-col p-[10px] ml-[20px] mt-[20px]">
                                <div className="flex flex-col">
                                    <div className="flex bg-[#f4f6fa] rounded-full py-[12px] px-[20px] mb-[15px] items-center border-[2px] border-[#a78859] shadow-md">
                                        <img src={tokens[CHAIN][selectedToken].icon} loading="lazy" alt="" className="h-[32px] mr-[10px] mt-[5px]" />
                                        <div className="relative grow">
                                            <label className="rounded-full min-w-[0px] absolute -left-[20px] -top-[25px] bg-[white] px-[10px] py-[5px] text-[12px] text-black">Payment token: <span className='font-bold'>{tokens[CHAIN][selectedToken].symbol}</span></label>
                                            <input type="number" value={amount0} min={200} require={true} onChange={(e) => {setAmount0(e.target.value)}} className="bg-transparent text-[black] pt-[8px] w-full outline-none appearance-none" maxLength="256" placeholder="200"/>
                                        </div>
                                        <div className="text-[#a78859] mt-[8px]">${usdBalance}</div>
                                        
                                    </div>
                                    <div className="flex bg-[#f4f6fa] rounded-full py-[12px] px-[20px] mb-[15px] items-center border-[2px] border-[#a78859] shadow-md">
                                        <img src="https://assets.website-files.com/642437f6e7664b300f156ac6/64528d4e13634e2a5f6df610_ls.png" loading="lazy" alt="" className="h-[32px] mr-[10px] mt-[5px]" />
                                        <div className="relative grow flex justify-between">
                                            <label className="rounded-full absolute -left-[20px] -top-[25px] bg-[white] px-[10px] py-[5px] text-[12px] text-black">Receiving token :  <span className='font-bold'> LXS </span> </label>
                                            <p className="bg-transparent text-black pt-[8px] outline-none grow">
                                                {amount1}
                                            </p>
                                            <p className="bg-transparent pt-[8px] outline-none text-[#a78859]">
                                                LXS
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-center mb-[10px] ml-[20px]">
                                        { tokens[CHAIN].map((token, index) => 
                                            <button key={index} className={"border-[#00587a] border-solid" + (index === selectedToken ? " p-[4px] border-[2px] rounded-full" : " p-[4px]")}
                                                onClick={() => {selectToken(index)}}
                                            >
                                                <img src={token.icon} loading="lazy" alt="" className="w-[24px]" />
                                            </button>
                                        )}
                                    </div>
                                    <div className="bg-[#f4f6fa] rounded-[12px] p-[12px]">
                                        <p className="text-[#363636] text-[12px]">Payment options for LuxuryShares (LXS) will be visible after you connect your wallet with Metamask, Coinbase, or Wallet Connect. Please note that it may take a few minutes or longer, depending on the cryptocurrency you are using, to deposit your new tokens into your wallet. If you have any questions, please contact our support team.</p>
                                    </div>
                                    <div className="grow min-h-[50px]"></div>
                                    { active && 
                                        <div className="m-[10px] px-[10px] bg-[#c4a678] rounded-[10px] p-[5px] flex justify-between items-center">
                                            <p className="text-white text-[12px]"> Your wallet: {`${account.substring(0, 7)}...${account.substring(38)}`} </p>
                                            <button className="flex justify-center items-center bg-[#00000050] hover:bg-[#000000a0] transitioin-all duration-300 text-[#c0c0c0] w-[16px] h-[16px] rounded-full text-[8px]"
                                                onClick={() => {disconnectWallet()}}
                                            >
                                                <p className='text-[8px]'> X </p>
                                            </button>
                                        </div>
                                    }
                                    <div>
                                        { (account && !approved) &&
                                            <button className="w-full bg-[#a78859] text-[24px] mt-[10px] py-[8px]" onClick={() => {onApproveClicked()}}>
                                                <p className="w-full text-white">Approve</p>
                                            </button>
                                        }
                                        { !account &&
                                            <button className="w-full bg-[#a78859] text-[24px] mt-[10px] py-[8px]"
                                                onClick={() => showWalletList(true)}
                                            >
                                                <p className="w-full text-white">Connect Wallet</p>
                                            </button>
                                        }
                                        { account && approved &&
                                            <button className="w-full bg-[#a78859] text-[24px] mt-[10px] py-[8px]"
                                              onClick={() => {buyToken()}}  
                                            >
                                                <p className="w-full text-white">BUY NOW</p>
                                            </button>
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="flex flex-col p-[10px] ml-[20px] mt-[10px] grow">
                                <div className="flex flex-col">
                                    <button className="flex items-center w-full bg-[#a78859] text-[24px] mt-[10px] py-[5px]"
                                        onClick={() => handleConnectProvider("Metamask")}
                                    >
                                        <div className='w-[32px] h-[32px] ml-[20px] flex items-center'>
                                            <img src="https://daks2k3a4ib2z.cloudfront.net/63c043814a8ff2df7aed9339/63c93af69cb1666320081f41_MetaMask.png" loading="lazy" alt="" className="w-[24px]" />
                                        </div>
                                        <p className="w-full text-white text-left ml-[10px]">metamask</p>
                                        <div className='w-[40px] h-[40px] mr-[20px] flex items-center'>
                                            <img src="https://daks2k3a4ib2z.cloudfront.net/63c043814a8ff2df7aed9339/63c93af8d76940e3f51c04c8_arrow_right.png" loading="lazy" alt="" className="w-[24px]" />
                                        </div>
                                    </button>
                                    <button className="flex items-center w-full bg-[#a78859] text-[24px] mt-[10px] py-[5px]"
                                        onClick={() => handleConnectProvider("Coinbase")}
                                    >
                                        <div className='w-[40px] h-[40px] ml-[20px] flex items-center'>
                                            <img src="https://daks2k3a4ib2z.cloudfront.net/63c043814a8ff2df7aed9339/63c93af605b175e23a05a378_Coinbase.png" loading="lazy" alt="" className="w-[24px]" />
                                        </div>
                                        <p className="w-full text-white text-left ml-[10px]">Coinbase</p>
                                        <div className='w-[40px] h-[40px] mr-[20px] flex items-center'>
                                            <img src="https://daks2k3a4ib2z.cloudfront.net/63c043814a8ff2df7aed9339/63c93af8d76940e3f51c04c8_arrow_right.png" loading="lazy" alt="" className="w-[24px]" />
                                        </div>
                                    </button>
                                    <button className="flex items-center w-full bg-[#a78859] text-[24px] mt-[10px] py-[5px]"
                                        onClick={() => handleConnectProvider("WalletConnect")}
                                    >
                                        <div className='w-[40px] h-[40px] ml-[20px] flex items-center'>
                                            <img src="https://daks2k3a4ib2z.cloudfront.net/63c043814a8ff2df7aed9339/63c93af7285714356c5e8a49_WalletConnect.png" loading="lazy" alt="" className="w-[24px]" />
                                        </div>
                                        <p className="w-full text-white text-left ml-[10px]">Wallet connect</p>
                                        <div className='w-[40px] h-[40px] mr-[20px] flex items-center'>
                                            <img src="https://daks2k3a4ib2z.cloudfront.net/63c043814a8ff2df7aed9339/63c93af8d76940e3f51c04c8_arrow_right.png" loading="lazy" alt="" className="w-[24px]" />
                                        </div>
                                    </button>
                                    <div className="grow min-h-[100px]"/>
                                    <button className="w-full bg-[#a78859] text-[24px] mt-[10px] py-[8px]"
                                        onClick={() => showWalletList(false)}
                                    >
                                        <p className="w-full text-white">Back</p>
                                    </button>
                                    
                                </div>
                            </div>
                            }
                          </div>
                    </div>
                </div>
            }
            { overlay && 
              <div className="fixed top-0 left-0 flex flex-col w-full h-[100vh] justify-center items-center backdrop-blur-xl flex overflow-y-auto py-[50px]">
                <Circles width={50} height={50} color="white"/>
                <p className='text-[1.5rem] text-white mt-[10px]'> Running... </p>
              </div>
            }
            
            <ToastContainer/>
        </div>

    )
}